import { selfAxios } from "../../../axios/selfAxios.js";
async function postSelectMarketRankByCon(params) {
  const { data } = await selfAxios.post(`/ma/orderActivityApi/selectMarketRankByCon`, params);
  return data == null ? void 0 : data.data;
}
export { postSelectMarketRankByCon };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/orderActivityApi/selectMarketRankByCon/post.js